import { createHttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';
import { setContext } from 'apollo-link-context';
import { authService } from '../authService';
import { GRAPHQL_ENDPOINT } from '../../endpoints';

/**
 * The most common Apollo link. Used to fetch GraphQL results from our
 * provided GraphQL endpoint. This link supports both POST and GET requests.
 */
export function createGraphqlLink() {
    return createHttpLink( { uri: GRAPHQL_ENDPOINT } );
}

/**
 * In the event that one of our GraphQL requests fails for some reason,
 * this link adds the ability to attempt the request again some number
 * of times in case there are intermitent failues for some reason.
 * 
 * _Current Configuration:_ Attempt to retry up to 5 times with a 1000ms
 * delay after the request failure.
 */
export function createRetryLink() {
    return new RetryLink( { delay: () => 1000, attempts: { max: 5 } } );
}

/**
 * Attached additional headers to our GraphQL requests in case
 * authorization is needed.
 */
export function createAuthLink() {
    return setContext( ( _, { headers } ) => {
        const accessToken = 'Bearer ' + authService.getAccessToken();
        // const accessToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwczovL3FhLmFwaS5iaXcuY2xvdWQvdjEvaWQiLCJpbnRlZ3JpdHkiOiJ2SlNQOGVhekFFWSIsImlhdCI6MTYwNjE0MTE2OCwiYW1yIjoicHdkIiwiYXVkIjoiaG95YSIsImNtcCI6ImYwNzlkN2ExLTdhNTYtNDZjNy1hZDJkLTg4MTM0ZDFiNGE1ZCIsImp0aSI6IjRwUGxQYVdWMThFTVlDYmxjU1IwT0xpbkJrWVYzNzd5bVZQNkZtNlpuZXQiLCJzY29wZSI6ImNteC5jcmVhdGUtcHJvamVjdCBjbXguY3JlYXRlLWtleSBjbXguZWRpdC1rZXkgY214LmVkaXQtY3VzdG9tLXN0cmluZyBjbXguZWRpdC1nb2xkLXN0cmluZyIsInRva2VuX3R5cGUiOiJjbGllbnRfY3JlZGVudGlhbHMiLCJwZXJtaXNzaW9ucyI6eyJjbXgiOlsiY3JlYXRlLXByb2plY3QiLCJjcmVhdGUta2V5IiwiZWRpdC1rZXkiLCJlZGl0LWN1c3RvbS1zdHJpbmciLCJlZGl0LWdvbGQtc3RyaW5nIl19LCJuYmYiOjE2MDYxNDA4NjgsImV4cCI6MTYwNjE2OTk2OH0.cn9nIjYr-pBx7XA8yup-50-2xyBSGKvT6uHOmAqpomc';

        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
                authorization: accessToken,
                // ...
            }
        };
    } );
}
